import type { OrderStatus } from "../api/types";
import { ORDER_STATUS_LABELS, orderBadgeClass } from "./orderStatus";

/**
 * An order's state, in words.
 *
 * The colour is decoration. What carries the meaning is the text inside the
 * badge, which is why the label is rendered rather than the class alone —
 * an operator who cannot distinguish the greens, or who is reading this
 * through a screen reader, gets the same answer as everybody else.
 */
export function OrderStatusBadge({ status }: { status: OrderStatus | string }) {
  const label =
    status in ORDER_STATUS_LABELS
      ? ORDER_STATUS_LABELS[status as OrderStatus]
      : // A state this build has no label for is printed as the backend spells
        // it, rather than as a blank badge. That is what an operator can quote
        // in a support thread.
        String(status).replace(/_/g, " ");

  return <span className={orderBadgeClass(status)}>{label}</span>;
}
